module.exports = __webpack_public_path__ + "img/sha_02.fca2fc55.jpg";